import { render, staticRenderFns } from "./OrderWarnings.vue?vue&type=template&id=7ea68cc4&"
import script from "./OrderWarnings.vue?vue&type=script&lang=js&"
export * from "./OrderWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports